<template>
    <Transition name="slide-up">
        <div
            v-if="count > 0"
            class="tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:z-40 tw:bg-white tw:border-t tw:border-slate-200 tw:shadow-xl tw:px-4 tw:py-4 tw:flex tw:items-center tw:justify-between tw:gap-4 tw:sm:px-6"
        >
            <div>
                <p class="tw:m-0 tw:text-sm tw:font-semibold tw:text-slate-700">
                    {{ $t('perfil.plazos_seleccionados', { count }) }}
                </p>
                <p class="tw:m-0 tw:text-lg tw:font-extrabold tw:text-slate-900">
                    {{ formatearPrecio(total) }}
                </p>
            </div>
            <Button
                variant="alt"
                icon="material-icons tw:text-base payment"
                @click="emit('open')"
            >
                {{ ctaLabel }}
            </Button>
        </div>
    </Transition>
</template>

<script setup>
    import { computed } from 'vue';
    import { t } from '@/utils/i18n-helper';
    import { useFilters } from '@/composables/front/formatters/useFilters';
    import Button from '@/modules/front/ui/Button.vue';

    const props = defineProps({
        count: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
        },
        ctaText: {
            type: String,
            default: '',
        },
    });

    const emit = defineEmits(['open']);

    const { formatearPrecio } = useFilters();

    const ctaLabel = computed(() => props.ctaText || t('perfil.pagar_seleccionados'));
</script>

<style scoped>
    .slide-up-enter-active {
        animation: slide-up-in 0.25s ease;
    }

    .slide-up-leave-active {
        animation: slide-up-out 0.25s ease;
    }

    @keyframes slide-up-in {
        from {
            transform: translateY(100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes slide-up-out {
        from {
            transform: translateY(0);
            opacity: 1;
        }
        to {
            transform: translateY(100%);
            opacity: 0;
        }
    }
</style>
